"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcHeroVisibility_updateTick = void 0;
var diveDebug_sidecar_1 = require("@dive/debug/diveDebug-sidecar");
var diveObjects_sidecar_1 = require("@dive/entities/diveObjects-sidecar");
var diveSimulationManager_sidecar_1 = require("@dive/simulation/diveSimulationManager-sidecar");
var diveTilemap_sidecar_1 = require("@dive/tilemap/diveTilemap-sidecar");
var lineAlgo_sidecar_1 = require("@dive/to-engine/lineAlgo-sidecar");
var perf2_sidecar_1 = require("@engine/perf2-sidecar");
var diveCrew_hero_sidecar_1 = require("@voyage/crew/diveCrew_hero-sidecar");
var diveCrew_pet_sidecar_1 = require("@voyage/crew/diveCrew_pet-sidecar");
var diveCrew_sidecar_1 = require("@voyage/crew/diveCrew-sidecar");
var namespace = 'dive-calc-hero-visibility';
var currentVisibilityIdx = 0;
function calcHeroVisibility_updateTick() {
    perf2_sidecar_1.perf2.measure('calcHeroVisibility_updateTick', function () {
        currentVisibilityIdx = diveSimulationManager_sidecar_1.diveSimulationManager.getCurrentVisibilityIndex();
        if (diveDebug_sidecar_1.diveDebug.debug_seeEverything) {
            // This is much faster than going through i/j
            var tiles = diveTilemap_sidecar_1.diveTilemap.getAllTiles();
            for (var iTile = 0; iTile < tiles.length; iTile++) {
                var gs = tiles[iTile];
                gs.visibilityIdx = currentVisibilityIdx;
            }
            return;
        }
        // console.log('calc visibility')
        // Get all heroes
        var heroesAndPets = diveCrew_hero_sidecar_1.diveCrew_hero.getAllHeroes();
        heroesAndPets.push.apply(heroesAndPets, __spreadArray([], __read(diveCrew_pet_sidecar_1.diveCrew_pet.getAllPets())));
        var _loop_1 = function (iHeroAndPet) {
            var m = heroesAndPets[iHeroAndPet];
            // Calculate visibility for this hero
            if (diveCrew_sidecar_1.diveCrew.isDeadish(m)) {
                return "continue";
            }
            // console.log('calc visibility for hero', m.id)
            var visionRange = diveDebug_sidecar_1.diveDebug.debug_defaultVisionRange;
            var plot = function (pi, pj, c, c2) {
                if (c2 > visionRange) {
                    return false;
                }
                var gs = diveTilemap_sidecar_1.diveTilemap.getSafe(pi, pj);
                if (!gs) {
                    return false;
                }
                // Ok! set it as visibile!
                gs.visibilityIdx = currentVisibilityIdx;
                // TODO: vision vs walkable for tiles
                if (!gs.tile1.canWalk) {
                    return false;
                }
                // Check for blocking objects
                // TODO: speed this up
                for (var iObject = 0; iObject < gs.objects.length; iObject++) {
                    var obj = gs.objects[iObject];
                    if (!diveObjects_sidecar_1.diveObjects.isWalkable(obj)) {
                        return false;
                    }
                }
                return true;
            };
            for (var i = -visionRange; i <= visionRange; i++) {
                lineAlgo_sidecar_1.lineAlgo.drawLineBresenham(m.i, m.j, m.i + i, m.j + visionRange, plot);
                lineAlgo_sidecar_1.lineAlgo.drawLineBresenham(m.i, m.j, m.i + i, m.j - visionRange, plot);
            }
            for (var j = -visionRange; j <= visionRange; j++) {
                lineAlgo_sidecar_1.lineAlgo.drawLineBresenham(m.i, m.j, m.i + visionRange, m.j + j, plot);
                lineAlgo_sidecar_1.lineAlgo.drawLineBresenham(m.i, m.j, m.i - visionRange, m.j + j, plot);
            }
        };
        for (var iHeroAndPet = 0; iHeroAndPet < heroesAndPets.length; iHeroAndPet++) {
            _loop_1(iHeroAndPet);
        }
        // const end = performance.now()
        // let ms = end - start
        // if (ms > 1.5) {
        //   console.log(namespace, `${ms} ms`)
        // }
    });
}
exports.calcHeroVisibility_updateTick = calcHeroVisibility_updateTick;
